const english = {
  steps: {
    EmailVerification: 'E-mail Verification',
    RequestAccess: 'Request For Access',
    UserInfo: 'Contact Information',
    SelectCompany: 'Select Company',
    BusinessInfo: 'Company Information',
    Diversity: 'Diversity Information',
    Products: 'Products & Services',
    Login: 'Login Information'
  },
  backButtonLabel: 'Back',
  continueButtonLabel: 'Continue',
  affirmativeLabel: 'Yes',
  negativeLabel: 'No',
  expandIconTooltip: 'Expand',
  collapseIconTooltip: 'Collapse',
  emailCheck: {
    languageLabel: 'Select Language',
    validEmail: 'Please insert a valid e-mail',
    enterEmail: 'Enter your e-mail',
    welcome: ''
  },
  emailValidationCode: {
    emailValidationTitle: 'An e-mail has been sent to {email} with a verification code. Please enter the code below.',
    termsOfUse: 'Terms of Use',
    aknowledge: `Your use of the site is governed by these {terms}. By clicking "Continue" button below, you acknowledge that you have read these Terms of Use and you accept and agree that, each time you use the Site, you will be bound by the Terms of Use then accessible through the link(s) on the login page.`,
    validationCodeLabel: 'Verification Code',
    sendCodeLabel: 'Send Code',
    resendCodeLabel: 'Resend Code',
    validationErrorMessage: 'Please insert the received Verification Code!',
    incorrectValidationCode: 'Incorrect Verification Code',
    userNotAllowToProceedMsg: 'There is an inactive account associated with this e-mail address. Please contact ',
    paSupportEmail: 'support@poweradvocate.com',
    reSentLabel: 'Your Verification Code has been resent',
    modalActiveAccount: 'Thank you for registering. An active account exists with the e-mail address you entered',
    modalEmailExistsText: 'The following existing accounts have been found with the e-mail address {email}.',
    modalEmailExistsGuide: 'Please choose an existing account or create a new account for a different company.',
    newUserAccountLabel: 'Create New Account'
  },
  requestAccess: {
    helpText:
      'To request access to this bid event, provide a reason below and click continue. Your request for access will be approved or denied by the Event Coordinator and you will receive further instructions via e-mail.',
    textAreaLabel: 'Reason for request for access',
    modalEmailNotInvitedText: [
      'Your e-mail address does not match the individual who was originally invited, possibly because the invitation was forwarded to you.',
      'Please click "Cancel" to enter a different e-mail address or click "Ok" to complete setting up your account.',
      'Your request for access will be approved or denied by the {role} and you will receive further instructions via e-mail.'
    ],
    eventCoordinator: 'Event Coordinator',
    portalOwner: 'Portal Owner',
    contractOwner: 'Contract Owner',
    modalCancelButton: 'Cancel',
    modalOkButton: 'Ok',
    modalLoginButton: 'Login'
  },
  userInfo: {
    salutation: [
      { label: '----', value: '' },
      { label: 'Mx.', value: 'Mx.' },
      { label: 'Mr.', value: 'Mr.' },
      { label: 'Mrs.', value: 'Mrs.' },
      { label: 'Ms.', value: 'Ms.' },
      { label: 'Dr.', value: 'Dr.' }
    ],
    firstName: 'First Name',
    lastName: 'Last Name',
    workPhone: 'Work Phone',
    jobTitle: 'Job Title',
    timeZone: 'Select Timezone*',
    reStart: 'Restart Registration'
  },
  companySelection: {
    helpText: "Search our database for your company. If it doesn't exist, add it.",
    companySearchLabel: 'Select Company',
    locationControlsHelpText: 'Please complete the following fields',
    siteName: 'Site Name',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    country: 'Country',
    city: 'City',
    stateProvince: 'State or Province',
    zip: 'Zip / Postal code',
    phoneNumber: 'Site Phone Number',
    siteTypeCode: 'Site Type',
    companyNotFound: 'Company "{text}" not listed? Click to add it.',
    tableCompanyNotFound: 'Company does not have locations. Please add a new location below.',
    tableTitle: 'Select one of the existing locations',
    tableSelect: 'Select',
    tableSiteName: 'Site Name',
    tableAddress: 'Address',
    tableStateProvince: 'State/Province',
    tableZip: 'Zip/Postal Code',
    tablePhone: 'Phone',
    loadingLabel: 'Getting company locations',
    radioLabel: 'Location not listed? Add New Location',
    companyDuplicatedName: 'This company name already exists. Please select the existing company or update the name.',
    sortingLabelAlpha: 'Sort companies alphabetically {sortOption}',
    sortingLabelUsers: 'Sort companies by number of active users {sortOption}',
    sortingLabelRelevancy: 'Reset Sort',
    sortAscending: 'ascending',
    sortDescending: 'descending',
    activeAccountsLabel: 'active accounts',
    domainSearchLabel: 'We found the following list of companies related to your email address domain: {emailAddress}',
    errorCompanyAlreadyRegistered:
      "This company has an existing account with this e-mail address. Please click 'Back' and select it."
  },
  companyBio: {
    companyLegalName: 'Company Legal Name',
    companyDoingBusinessAs: 'Doing Business As',
    companyParentCompany: 'Parent Company (if applicable)',
    yearCompanyWasFounded: 'Year Founded',
    numberOfPermanentEmployees: 'Permanent Employees',
    supplierCompanyOwnership: 'Company Ownership*',
    supplierCompanyOwnershipOptions: [
      { label: 'Privately Owned', value: 'Privately Owned' },
      { label: 'Publicly Owned', value: 'Publicly Owned' },
      { label: 'Government Owned', value: 'Government Owned' }
    ],
    unionizedCompany: 'Company is Unionized',
    companyPhoneNumber: 'Company Phone Number',
    companyWebsite: 'Company Website',
    errorCompanyWebsite: 'Please insert a valid URL',
    companyEmailAddress: 'Company e-mail',
    errorEmailAddress: 'Please insert a valid e-mail',
    companyTaxIdNumber: 'Company Tax ID Number (EIN)',
    errorTaxIdNumber: 'Tax ID should be 9 digits',
    dunsNumber: 'Company DUNS Number',
    errorDunsNumber: 'DUNS Number should be 9 digits',
    primaryNAICSCode: 'Company Primary NAICS Code',
    secondaryNAICSCode: 'Company Secondary NAICS Code',
    errorNAICSCode: 'NAICS Code should be between 2 to 6 digits',
    annualRevenueLabel: 'Annual revenue for {newAnnualRevenue} (USD)'
  },
  diversity: {
    radioGroupLabel: 'Do you have a Diversity Classification?',
    errorDiversityList: 'There was an error, try again later',
    errorUploadingFile: 'Error uploading file, try again later',
    errorRequiredField: '*Required field',
    errorForbiddenCharacters: `Filename Must not include Forbidden Characters: < > + & # ' / \\ * ? | "`,
    errorPermitedTypeFile: 'Permitted file types: jpg, jpeg, gif, png, bmp, pdf, doc, docx',
    errorDates: 'Start date cannot be after expiration date.',
    permitedTypeFileTooltip: 'Upload Certificate - Permitted file types: jpg, jpeg, gif, png, bmp, pdf, doc, docx',
    tableColumns: [
      { id: 'classification', label: 'Diversity Classification' },
      { id: 'document', label: 'Diversity Certificate', align: 'center' },
      { id: 'certificate', label: 'Certificate ID', align: 'center' },
      { id: 'startDate', label: 'Start Date', align: 'center' },
      { id: 'expDate', label: 'Expiration Date', align: 'center' }
    ],
    note:
      'NOTE: This information can be updated after registration is complete by logging into the platform and clicking on the Diversity link.',
    modalText: 'Please confirm you want to remove: {fileName}',
    modalCancelButton: 'Cancel',
    modalDeleteButton: 'Delete'
  },
  productsServices: {
    searchPlaceholder: 'Search...',
    cancelIconTooltip: 'Cancel',
    selectedProductsListTitle: 'Selected Products & Services',
    addProductTooltip: 'Add Product',
    removeProduct: 'Remove selected'
  },
  confirmation: {
    helperText: 'Enter a Username and Password for your login',
    submitButtonText: 'Submit & Login',
    userNameError: 'Username should be at least 8 characters long',
    passwordError:
      'Password must have at least 8 characters with 1 uppercase, 1 lowercase, 1 special character and 1 number',
    passwordConfirmationError: 'The passwords must match',
    usernameLabel: 'Username',
    passwordnameLabel: 'Password',
    confirmationPassLabel: 'Confirm Password',
    usernameTaken: 'Username is already taken',
    successResponse: 'Supplier registered successfully',
    errorResponse:
      'We are unable to save your registration. Please try again. If the problem continues please contact support@poweradvocate.com.'
  },
  common: {
    tagInstructionPrimary: 'This data has been generated from a prior submission by your company on {taggedDate}',
    tagInstructionSecondary: 'Please review all fields before selecting'
  },
  footer: {
    poweredBy: 'Powered by ',
    rightsReserved: 'All Rights Reserved',
    termsOfUse: 'Terms of Use',
    privacyStatement: 'Privacy Statement',
    contactSupport: 'Contact Support'
  },
  registrationLinkExpired: {
    headerText: 'Registration Expired',
    title: 'This Registration has expired.',
    description: 'To register anyway and create an account for future opportunities please click ',
    here: 'here'
  }
};

export default english;
